import { Location } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { safeReturnUrl } from '../../../core/security/mock-test-security.guard';
import { ImageEnum } from '../../utils/image.enum';

const COPIED_STATE_MS = 2500;

@Component({
  selector: 'app-private-browsing-blocked',
  imports: [],
  templateUrl: './private-browsing-blocked.html',
  styleUrl: './private-browsing-blocked.css',
})
export class PrivateBrowsingBlockedComponent {
  protected readonly imageEnum = ImageEnum;
  protected readonly linkCopied = signal(false);

  // Absolute link to the page the candidate was blocked from, to paste into a normal window.
  protected readonly testLink = new URL(
    inject(Location).prepareExternalUrl(
      safeReturnUrl(inject(ActivatedRoute).snapshot.queryParamMap.get('returnUrl')),
    ),
    window.location.origin,
  ).href;

  private copiedTimer?: ReturnType<typeof setTimeout>;

  protected async copyTestLink(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.testLink);
    } catch {
      // navigator.clipboard only exists in secure contexts (https/localhost).
      copyWithHiddenTextarea(this.testLink);
    }

    this.linkCopied.set(true);
    clearTimeout(this.copiedTimer);
    this.copiedTimer = setTimeout(() => this.linkCopied.set(false), COPIED_STATE_MS);
  }
}

function copyWithHiddenTextarea(text: string): void {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  textarea.remove();
}
